import { DataTypeColumn } from 'components/DataExpansionComponents/Common/commonColumnHelpers'
import { SampleRequest } from '../../models/samples'

type CustomFields =
  | 'company'
  | 'location'
  | 'actions'
  | 'location_firstbite_id'
  | 'company_firstbite_id'

export const SAMPLES_COLUMNS = {
  // Order Details group
  request_number: {
    header: 'Request #',
    group: 'Order Details',
  },
  created: {
    header: 'Created',
    group: 'Order Details',
  },
  date_needed: {
    header: 'Need by',
    group: 'Order Details',
  },
  status: {
    header: 'Status',
    group: 'Order Details',
  },
  status_display: {
    header: 'Status',
    group: 'Order Details',
  },
  fulfillment_option_display: {
    header: 'Fulfillment Option',
    group: 'Order Details',
  },

  // Fulfillment tracking group (FIR-7033)
  tracking_number: {
    header: 'Tracking Number',
    group: 'Fulfillment',
  },
  tracking_carrier_display: {
    header: 'Carrier',
    group: 'Fulfillment',
  },
  shipped_date: {
    header: 'Shipped Date',
    group: 'Fulfillment',
  },
  location: {
    header: 'Location',
    group: 'Order Details',
  },
  location_name: {
    header: 'Location Name',
    group: 'Order Details',
  },
  location_address: {
    header: 'Location Address',
    group: 'Order Details',
  },
  location_firstbite_id: {
    header: 'Firstbite Location ID',
    group: 'Order Details',
  },
  line_items: {
    header: 'Products',
    group: 'Order Details',
  },
  line_items_count: {
    header: 'Number of Products',
    group: 'Order Details',
  },

  // Requestor Info group
  user_name: {
    header: 'Requestor',
    group: 'Requestor Info',
  },
  user_email: {
    header: 'Requestor Email',
    group: 'Requestor Info',
  },
  company: {
    header: 'Company',
    group: 'Requestor Info',
  },
  company_name: {
    header: 'Company Name',
    group: 'Requestor Info',
  },
  company_firstbite_id: {
    header: 'Firstbite Company ID',
    group: 'Requestor Info',
  },

  // Timestamps
  modified: {
    header: 'Last Modified',
    group: 'Order Details',
  },

  // Shipping
  ship_to_name: {
    header: 'Ship-To Name',
    group: 'Shipping',
  },
  contact_email: {
    header: 'Ship-To Email',
    group: 'Shipping',
  },
  contact_phone: {
    header: 'Ship-To Phone',
    group: 'Shipping',
  },
  shipping_address_line1: {
    header: 'Ship-To Address Line 1',
    group: 'Shipping',
  },
  shipping_address_line2: {
    header: 'Ship-To Address Line 2',
    group: 'Shipping',
  },
  shipping_city: {
    header: 'Ship-To City',
    group: 'Shipping',
  },
  shipping_state: {
    header: 'Ship-To State',
    group: 'Shipping',
  },
  shipping_zip: {
    header: 'Ship-To Zip',
    group: 'Shipping',
  },
  shipping_country: {
    header: 'Ship-To Country',
    group: 'Shipping',
  },
} satisfies Partial<Record<keyof SampleRequest | CustomFields, DataTypeColumn>>
